export const APP_I18_KEYS = {
  RESOURCES: {
    MAIN: "MAIN",
  },
} as const;
